import styled from 'styled-components'

export const ModalBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	backdrop-filter: blur(2px);
	padding: 20px;
`

export const ModalContainer = styled.div<{ size: 'small' | 'medium' | 'large'; backgroundColor?: string }>`
	background: ${({ backgroundColor }) => backgroundColor || 'white'};
	border-radius: 12px;
	box-shadow:
		0 20px 25px -5px rgba(0, 0, 0, 0.1),
		0 10px 10px -5px rgba(0, 0, 0, 0.04);
	width: 100%;
	max-height: 90vh;
	overflow: visible;
	animation: modalSlideIn 0.2s ease-out;
	display: flex;
	flex-direction: column;
	position: relative;

	${({ size }) => {
		switch (size) {
			case 'small':
				return 'max-width: 400px;'
			case 'medium':
				return 'max-width: 500px;'
			case 'large':
				return 'max-width: 700px;'
			default:
				return 'max-width: 500px;'
		}
	}}

	@keyframes modalSlideIn {
		from {
			opacity: 0;
			transform: translateY(-10px) scale(0.95);
		}
		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}
`

export const ModalHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 24px 24px 0 24px;
	border-bottom: 1px solid #e5e7eb;
	padding-bottom: 16px;
	flex-shrink: 0;
`

export const ModalTitle = styled.h2`
	margin: 0;
	font-size: 20px;
	font-weight: 600;
	color: #111827;
`

export const CloseButton = styled.button<{ color?: string }>`
	background: transparent;
	border: none;
	font-size: 24px;
	color: #000000;
	cursor: pointer;
	padding: 4px;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	transition: all 0.2s;

	&:hover {
		color: #000000;
	}
`

export const DeleteButton = styled.button`
	background: transparent;
	border: none;
	font-size: 18px;
	color: #dc2626;
	cursor: pointer;
	padding: 4px;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	transition: all 0.2s;

	&:hover {
		color: #991b1b;
	}
`

export const ModalBody = styled.div`
	padding: 24px;
	flex: 1;
	overflow: visible;
	min-height: 0;
`

export const ModalFooter = styled.div`
	padding: 0 24px 24px 24px;
	border-top: 1px solid #e5e7eb;
	padding-top: 16px;
	flex-shrink: 0;
`
